module.exports = __webpack_public_path__ + "img/animasi-major.b9d56cb1.png";